/** Owner plan upgrade request API helper. */

export const OWNER_UPGRADE_REQUEST_PATH = '/owner/plan-upgrade-requests';

export function buildOwnerUpgradeRequestBody(requestedPlanId) {
  return { requested_plan_id: String(requestedPlanId || '').toUpperCase() };
}
